module.exports = __webpack_public_path__ + "img/sleeve_flounces_length.ae0b4549.png";